import { render, staticRenderFns } from "./view-bulk-message-send-summary.vue?vue&type=template&id=01df22b8&scoped=true&"
import script from "./view-bulk-message-send-summary.vue?vue&type=script&lang=js&"
export * from "./view-bulk-message-send-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01df22b8",
  null
  
)

export default component.exports